import React from "react";
import LivePreviewPanelComponent from "./livePreviewPanel.component";

function LivePreviewPanelContainer({ luckyDraw, lang }) {
  return <LivePreviewPanelComponent luckyDraw={luckyDraw} lang={lang} />;
}

export default LivePreviewPanelContainer;
